import { render, staticRenderFns } from "./approvalModal.vue?vue&type=template&id=6cf58139&scoped=true"
import script from "./approvalModal.vue?vue&type=script&lang=js"
export * from "./approvalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf58139",
  null
  
)

export default component.exports